import { MediaTypes } from '@setplex/tria-api'

export { MediaTypes }

export enum MediaTypesExtended {
  TV_CHANNEL_CATCHUP = 'TV_CHANNEL_CATCHUP',
  TV_CHANNEL_BUNDLE = 'TV_CHANNEL_BUNDLE',
  TV_CHANNEL_IN_BUNDLE = 'TV_CHANNEL_IN_BUNDLE',
  VOD_BUNDLE = 'VOD_BUNDLE',
  VOD_IN_BUNDLE = 'VOD_IN_BUNDLE',
  TV_SHOW_BUNDLE = 'TV_SHOW_BUNDLE',
  TV_SHOW_IN_BUNDLE = 'TV_SHOW_IN_BUNDLE',
  TV_SHOW_SEASON = 'TV_SHOW_SEASON',
  TV_SHOW_SEASON_IN_BUNDLE = 'TV_SHOW_SEASON_IN_BUNDLE',
  TV_SHOW_EPISODE = 'TV_SHOW_EPISODE',
  TV_SHOW_EPISODE_IN_BUNDLE = 'TV_SHOW_EPISODE_IN_BUNDLE',
  PARTNER_PRODUCT = 'PARTNER_PRODUCT',
}

export enum MediaTypeInternal {
  __REFRESH__ = '__REFRESH__',
}

export type MediaTypesEx = MediaTypes | MediaTypesExtended | MediaTypeInternal

export type ExternalPaymentParams = {
  id: number
  mediaType?: MediaTypesEx | null
  shouldRefresh?: boolean

  // needed for tv shows episodes
  seasonId?: number
  tvShowId?: number

  // params for redirect to player, for different media types could be different
  params?: any // eslint-disable-line @typescript-eslint/no-explicit-any
  externalId?: string | null
}
